import { GenIcon } from 'react-icons'

const CmReturnable = GenIcon({
  tag: 'svg',
  attr: { viewBox: '0 0 8 9' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M0 4C0 2.625 1.10938 1.5 2.5 1.5H5V1C5 0.8125 5.10938 0.625 5.29688 0.546875C5.48438 0.46875 5.70312 0.515625 5.84375 0.65625L6.84375 1.65625C7.04688 1.84375 7.04688 2.17188 6.84375 2.35938L5.84375 3.35938C5.70312 3.5 5.48438 3.54688 5.29688 3.46875C5.10938 3.39062 5 3.20312 5 3V2.5H2.5C1.67188 2.5 1 3.17188 1 4C1 4.28125 0.765625 4.5 0.5 4.5C0.21875 4.5 0 4.28125 0 4ZM8 5C8 6.39062 6.875 7.5 5.5 7.5H3V8C3 8.20312 2.875 8.39062 2.6875 8.46875C2.5 8.54688 2.28125 8.5 2.14062 8.35938L1.14062 7.35938C0.9375 7.17188 0.9375 6.84375 1.14062 6.65625L2.14062 5.65625C2.28125 5.51562 2.5 5.46875 2.6875 5.54688C2.875 5.625 3 5.8125 3 6V6.5H5.5C6.32812 6.5 7 5.82812 7 5C7 4.73438 7.21875 4.5 7.5 4.5C7.76562 4.5 8 4.73438 8 5Z',
        fill: 'black'
      },
      child: []
    }
  ]
})

export default CmReturnable
